/**
 * Default renderer for table cells
 *
 * @param row
 * @param column
 * @returns
 */
export function renderCell(row, column, actions, rowState) {
    if (column.hidden) {
        return null;
    }
    const cellProps = {
        align: column.align,
        key: `${row.id}-${column.id}`,
        role: 'cell',
        spacing: column.spacing,
        span: column.span,
    };
    return column.renderCell(row, cellProps, actions, rowState);
}
//# sourceMappingURL=renderCell.js.map